import React, {useState, useEffect} from 'react';
import MathJax from "../../../components/react-mathjax-preview";
import MQTSelectBox from './MQTSelectBox';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper   } from '@mui/material';


const MQTDisplayOption2 = props => {
    const [questions, setQuestions] = useState([]);
    const [answers, setAnswers] = useState([]);

    useEffect(()=>{
        if(props.mqt_questions){
            setQuestions(shuffle(Object.values(props.mqt_questions), props.random_order))
        }
        console.debug("props.mqt_questions", props.mqt_questions)
    },[props.mqt_questions])

    useEffect(()=>{
        if(props.mqt_answers){
            setAnswers(shuffle(Object.values(props.mqt_answers), props.random_answer_order))
        }
        console.debug("props.mqt_answers", props.mqt_answers)
    },[props.mqt_answers])

    const shuffle=(arra1, random_order) =>{
        if(arra1 && random_order) {
          var ctr = arra1.length, temp, index;
          // While there are elements in the array
              while (ctr > 0) {
          // Pick a random index
                  index = Math.floor(Math.random() * ctr);
          // Decrease ctr by 1
                  ctr--;
          // And swap the last element with it
                  temp = arra1[ctr];
                  arra1[ctr] = arra1[index];
                  arra1[index] = temp;
              }
        } else {
            arra1 = arra1.sort((a, b) => parseInt(a.displayOrder) - parseInt(b.displayOrder));
        }
        return arra1;
    }


    return <div className='sf-mqt-container'>
        <div className='mt-2 mb-4'>Select your answers:</div>
        <div className='sf-mqt-table'>
            <table size="small" className={`${props.showAnswerResponse && !props.showSubmitLoader ? (props.answerCorrect ? "sf-mqt-correct" : 'sf-mqt-incorrect') : ''}`}>
                <thead align="center">
                    <tr>
                    {props.mqt_hide_question ? <td align='center' style={{display:"none"}}></td> : <td ></td>} 
                    {
                       answers.map(answer => {
                            let content = React.createElement(MathJax,{"math":answer.value});
                            return <td  sx={{border:'1px solid #EEF1F4'}} align="center">{content}</td>
                        })
                    }
                    </tr>
                </thead>
                <tbody>
                {
                   questions.map((question, index)=>{
                        let content   =   React.createElement(MathJax,{"math":question.value});
                        let radioButtons = [];
                        const question_answer_map = props.question_answer_map;
                        Object.keys(props.mqt_answers).forEach((answer,index)=>{
                            let answerIDs  =  question_answer_map[question.id];
                            let checked = false;
                            if(answerIDs && answerIDs.includes(answer))
                                checked = true;
                            console.debug("answers>>>", answers, answerIDs, answer, checked, question_answer_map[question.id]);
                            radioButtons.push(<td align='center' sx={{border:'1px solid #EEF1F4'}}> <MQTSelectBox checked={checked}  type={props.type} questionID={props.questionID} onClick={ (checked) =>{props.onAnswerChoice(checked,{qID:question.id,aID:answer})}} value={index+1}/></td>);
                        })
                        
                        return <tr key={index}>
                                {props.mqt_hide_question ? <td align='center' style={{display:"none"}}>{content}</td>: <td align='center' sx={{border:'1px solid #EEF1F4'}}>{content}</td>}    
                                    {radioButtons}
                                </tr>
                    })
                }
                </tbody>
            </table>
        </div>
        <table className='mqt-display-table d-none'>
            <thead>
                <tr>
                   {props.mqt_hide_question ? <th style={{display:"none"}}></th> : <th></th>} 
                    {
                       answers.map(answer => {
                            let content   =   React.createElement(MathJax,{"math":answer.value});
                            return <th>{content}</th>
                        })
                    }
                </tr>
            </thead>
            <tbody>
                {
                   questions.map(question=>{
                        let content   =   React.createElement(MathJax,{"math":question.value});
                        let radioButtons = [];
                        const question_answer_map = props.question_answer_map;
                        Object.keys(props.mqt_answers).forEach((answer,index)=>{
                            let answerIDs  =  question_answer_map[question.id];
                            let checked = false;
                            if(answerIDs && answerIDs.includes(answer))
                                checked = true;
                            console.debug("answers>>>", answers, answerIDs, answer, checked, question_answer_map[question.id]);
                            radioButtons.push(<td> <MQTSelectBox checked={checked}  type={props.type} questionID={props.questionID} onClick={ (checked) =>{props.onAnswerChoice(checked,{qID:question.id,aID:answer})}} value={index+1}/></td>);
                        })
                        
                        return <tr>
                                {props.mqt_hide_question ? <td align='center' style={{display:"none"}}>{content}</td>: <td align='center'>{content}</td>}    
                                    {radioButtons}
                                </tr>
                    })
                } 
            </tbody>
        </table>    
    </div>
}

export default MQTDisplayOption2;